import React, { useState } from 'react';
import './style.css';
import '../AntsTalk/style.css';
import NodeImg1 from '../../images/NodeImg01.png';
import NodeImg3 from '../../images/NodeImg03.png';
import NodeImg4 from '../../images/NodeImg04.png';
import FileDown from '../../images/downBtn.png';

export default function Community() {
    const [activeTab, setActiveTab] = useState('antstalk');
    const [downloading, setDownloading] = useState(false);

    const handleDownload = (url) => {
        setDownloading(true);
        window.location.href = url;
        setTimeout(() => setDownloading(false), 2000);
    };

    // 채팅 아이콘 SVG
    const ChatIcon = () => (
        <svg viewBox="0 0 100 100" className="chat-icon">
            <defs>
                <linearGradient id="chatGradientCommunity" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#01BCD6"/>
                    <stop offset="100%" stopColor="#006674"/>
                </linearGradient>
            </defs>
            <rect x="10" y="15" width="80" height="55" rx="10" fill="url(#chatGradientCommunity)"/>
            <polygon points="25,70 35,70 20,85" fill="url(#chatGradientCommunity)"/>
            <circle cx="35" cy="42" r="5" fill="#fff"/>
            <circle cx="50" cy="42" r="5" fill="#fff"/>
            <circle cx="65" cy="42" r="5" fill="#fff"/>
        </svg>
    );

    // 기능 아이콘들
    const FeatureIcon = ({ type }) => {
        const icons = {
            chat: (
                <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                </svg>
            ),
            group: (
                <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
            ),
            file: (
                <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                </svg>
            ),
            security: (
                <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
            ),
            notification: (
                <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                </svg>
            ),
            search: (
                <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                    <circle cx="11" cy="11" r="8"/>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
            )
        };
        return icons[type] || null;
    };

    return (
        <div className='CommunityContents'>
            <div className='HomeContainer'>
                {/* 탭 메뉴 */}
                <div className="CommunityTabs">
                    <button
                        className={`CommunityTabBtn ${activeTab === 'antstalk' ? 'active' : ''}`}
                        onClick={() => setActiveTab('antstalk')}
                    >
                        앤츠톡
                    </button>
                    <button
                        className={`CommunityTabBtn ${activeTab === 'nodemaster' ? 'active' : ''}`}
                        onClick={() => setActiveTab('nodemaster')}
                    >
                        노드마스터
                    </button>
                </div>

                {/* 노드마스터 탭 내용 */}
                {activeTab === 'nodemaster' && (
                    <div className="TabContent">
                        <div className="CommunityTopTxt">
                            <h1>생각을 정리하는<br/>가장 스마트한 방법</h1>
                            <p>떠오르는 모든 생각을 빠르고 쉽게 기록하고 관리하세요</p>
                        </div>
                        <div className="CommunitySection">
                            <h1>NodeMaster</h1>
                            <div className='CommunityFirst'>
                                <div className='ImgBox'>
                                    <img src={NodeImg1} alt="NodeMaster"/>
                                </div>
                                <div className='DownloadSection'>
                                    <h3>다운로드</h3>
                                    <div className='DownBtn'>
                                        <div className='DBtn'>
                                            <a>
                                                <p><span>클라우드</span>노드마스터 준비중</p>
                                                <img src={FileDown} alt="download"/>
                                            </a>
                                        </div>
                                        <div className='DBtn'>
                                            <a href={'files/NodeMasterLocal.msi'} download="NodeMasterLocal.msi">
                                                <p><span>로컬</span>노드마스터 다운로드 V 0.01</p>
                                                <img src={FileDown} alt="download"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='CommunitySecond'>
                                <div className='ContentBox'>
                                    <img src={NodeImg3} alt="NodeMaster Feature"/>
                                    <div className="InfoBox">
                                        <h2>데이터 정리 수집 프로그램</h2>
                                        <div className="CircleTags">
                                            <p>트리뷰와 웹 형태로 많은 자료를 목차형태로 볼 수 있는 정리 도구</p>
                                        </div>
                                        <div className="gradationBox">
                                            <ul>
                                                <li>계층 구조를 통한 내용의 카테고리화</li>
                                                <li>강력한 검색 기능</li>
                                                <li>체크리스트 기능 지원</li>
                                                <li>데이터의 안전한 저장/보호</li>
                                                <li>직관적인 UI</li>
                                                <li>단축키 활용으로 빠른 편집</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className='ContentBox'>
                                    <img src={NodeImg4} alt="NodeMaster Guide"/>
                                    <div className="InfoBox">
                                        <h2>Guide</h2>
                                        <div className="CircleTags">
                                            <p>하루 일정 정리</p>
                                            <p>배운 강의 내용 정리</p>
                                            <p>아이디어 정리</p>
                                            <p>기능</p>
                                        </div>
                                        <div className="gradationBox">
                                            <p className="colorTitle">하루 일정 정리</p>
                                            <p>사용자가 하루동안의 일정을 입력하고, 시간대나 카테고리 등으로 일정을 분류하고 관리할 수 있도록 합니다.</p>
                                        </div>
                                        <div className="gradationBox">
                                            <p className="colorTitle">배운 강의 내용 정리</p>
                                            <p>앤츠네스트에서 제공하는 강의를 수강하고, 핵심 내용을 정리하여 저장하고 복습할 수 있도록 합니다.</p>
                                        </div>
                                        <div className="gradationBox">
                                            <p className="colorTitle">아이디어 정리</p>
                                            <p>사용자가 창의적인 아이디어를 기록하고, 관리하며, 효율적으로 활용할 수 있도록 합니다.</p>
                                        </div>
                                        <div className="gradationBox">
                                            <p className="colorTitle">기능</p>
                                            <ul>
                                                <li>사용자 인증과 권한 관리를 구현하여 개인 정보와 중요한 데이터를 보호합니다.</li>
                                                <li>데이터를 클라우드에 안전하게 저장하고 백업할 수 있도록 합니다.</li>
                                                <li>사용자 인터페이스(UI)를 사용하기 쉽게 직관적으로 디자인하여 편리한 사용자 경험을 제공합니다.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* 앤츠톡 탭 내용 - 새 디자인 */}
                {activeTab === 'antstalk' && (
                    <div className="TabContent AntsTalkContents" style={{background: 'transparent', padding: 0, minHeight: 'auto'}}>
                        {/* 히어로 섹션 */}
                        <div className="AntsTalkHero">
                            <div className="HeroContent">
                                <div className="HeroText">
                                    <h1>AntsTalk</h1>
                                    <p className="HeroSubtitle">실시간 소통의 새로운 기준</p>
                                    <p className="HeroDesc">빠르고 안전한 메시징으로 팀과 함께 일하세요.<br/>앤츠네스트의 공식 메신저입니다.</p>
                                    <button
                                        className={`DownloadBtn ${downloading ? 'downloading' : ''}`}
                                        onClick={() => handleDownload('https://file.skynet.re.kr/biz_antsnest/f20260125_4yu6b3.exe')}
                                        disabled={downloading}
                                    >
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="download-icon">
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                            <polyline points="7 10 12 15 17 10"/>
                                            <line x1="12" y1="15" x2="12" y2="3"/>
                                        </svg>
                                        {downloading ? '다운로드 중...' : 'Windows 다운로드'}
                                    </button>
                                </div>
                                <div className="HeroIcon">
                                    <ChatIcon />
                                </div>
                            </div>
                        </div>

                        {/* 기능 섹션 */}
                        <div className="AntsTalkFeatures">
                            <h2>주요 기능</h2>
                            <div className="FeatureGrid">
                                <div className="FeatureCard">
                                    <div className="FeatureIconBox">
                                        <FeatureIcon type="chat" />
                                    </div>
                                    <h3>실시간 채팅</h3>
                                    <p>1:1 및 그룹 채팅으로 빠른 소통</p>
                                </div>
                                <div className="FeatureCard">
                                    <div className="FeatureIconBox">
                                        <FeatureIcon type="group" />
                                    </div>
                                    <h3>팀 협업</h3>
                                    <p>프로젝트별 채널로 체계적 관리</p>
                                </div>
                                <div className="FeatureCard">
                                    <div className="FeatureIconBox">
                                        <FeatureIcon type="file" />
                                    </div>
                                    <h3>파일 공유</h3>
                                    <p>문서, 이미지, 동영상 간편 전송</p>
                                </div>
                                <div className="FeatureCard">
                                    <div className="FeatureIconBox">
                                        <FeatureIcon type="security" />
                                    </div>
                                    <h3>보안</h3>
                                    <p>종단간 암호화로 안전한 대화</p>
                                </div>
                                <div className="FeatureCard">
                                    <div className="FeatureIconBox">
                                        <FeatureIcon type="notification" />
                                    </div>
                                    <h3>알림 설정</h3>
                                    <p>맞춤형 알림으로 집중 모드</p>
                                </div>
                                <div className="FeatureCard">
                                    <div className="FeatureIconBox">
                                        <FeatureIcon type="search" />
                                    </div>
                                    <h3>메시지 검색</h3>
                                    <p>필요한 정보를 빠르게 찾기</p>
                                </div>
                            </div>
                        </div>

                        {/* 하단 CTA */}
                        <div className="AntsTalkCTA">
                            <h2>지금 바로 시작하세요</h2>
                            <p>앤츠톡과 함께 더 효율적인 팀 커뮤니케이션을 경험하세요</p>
                            <button
                                className={`DownloadBtn large ${downloading ? 'downloading' : ''}`}
                                onClick={() => handleDownload('https://file.skynet.re.kr/biz_antsnest/f20260125_4yu6b3.exe')}
                                disabled={downloading}
                            >
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="download-icon">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                    <polyline points="7 10 12 15 17 10"/>
                                    <line x1="12" y1="15" x2="12" y2="3"/>
                                </svg>
                                {downloading ? '다운로드 중...' : 'AntsTalk 다운로드'}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
